import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[96px] w-full rounded-[var(--radius-md)] border border-[var(--color-mist-300)] bg-[var(--color-white)] px-4 py-3 text-base text-[var(--color-charcoal)] shadow-none placeholder:text-[var(--color-stone-500)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-burgundy-500)] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
